import * as React from "react";
import { footerLabels } from "../../../Resoures/Contents";
import { Link } from "react-router";

interface IFooterProps {
    onClose: () => void;
}

export const Footer = (props: IFooterProps) => {
    const closeLightbox = (event: any) => {
        event.preventDefault();
        props.onClose();
    };

    return (
        <div className="cno-footer">
            <div className="row wide-gutter">
                <div className="col-12 col-xs-6 col-sm-4 col-md-3">
                    <h2 className="cno-column-heading e937">
                        <span className="icon" aria-hidden={true} />
                        {footerLabels.supportLabel}
                    </h2>
                    <ul className="cno-footer-links">
                        <li>
                            <a
                                href="https://www.abrdn.com/en-gb/platform-adviser/wrap/platform-help-centre"
                                className="hyperlink-external"
                                target="_blank"
                            >
                                {footerLabels.helpAndSupportLabel}
                            </a>
                        </li>
                        <li>
                            <a
                                href="https://www.abrdn.com/en-gb/platform-adviser/news/platform"
                                className="hyperlink-external"
                                target="_blank"
                            >
                                {footerLabels.newsLabel}
                            </a>
                        </li>
                    </ul>
                </div>
                <div className="col-12 col-xs-6 col-sm-4 col-md-3">
                    <h2 className="cno-column-heading e909">
                        <span className="icon" aria-hidden={true} />
                        {footerLabels.platformSettingsLabel}
                    </h2>
                    <ul className="cno-footer-links">
                        <li onClick={closeLightbox}>
                            <Link className="hyperlink-next" to={`/wpadviser/en-gb/dashboard/home/main/settings`}>
                                {footerLabels.settingsLabel}
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};
